import React, { useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import Space from "../layout/Space.js";
import { useEffect } from "react";
import {
  createDoc,
  getFlutterTime,
  getFlutterTimeFromSeconds,
  getRefFromId,
  updateDocDataField,
} from "../models/DataFunctions.js";

import CheckBoxGrey from "../textfields/CheckBoxGrey.js";

import moment from "moment";
import SmallSpinner from "../loading/SmallSpinner.js";
import TextField2 from "../textfields/TextField2.js";
import { InputNumber } from "antd";
import { useSnackbar } from "notistack";
import initiatePayment from "../api/folder/initiatePayment.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import { useAppContext } from "../config/AppContext.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import { setDoc, updateDoc } from "firebase/firestore";
import Icon1 from "../icons/Icon.js";
import TextField2T from "../textfields/TextField2T.js";
import updateDocApi from "../api/database/updateDocApi.js";
import createDocApi from "../api/database/createDocApi.js";
import { checkAndSendTriggerEvent } from "../config/TriggerEmailSystem.js";

const PaymentModal = ({
  document,
  folder,
  userData,

  index,
  paymentData,
  orgData,
  onClose,
  onUpdate,
  navigateWorkspace,
}) => {
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [loadingData = false, setLoadingData] = useState(false);
  const [reglement, setReglement] = useState(null);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  useEffect(() => {
    let reglement = folder.reglement.infos ? folder.reglement.infos : {};
    setReglement(reglement);
  }, []);

  const handleGeneratePayment = async () => {
    if (paymentData.amount <= 1) {
      handleClickVariant(
        "Le montant du paiement doit être supérieur à 1,00€",
        "error"
      );
      return;
    }
    // Initier la demande
    setLoadingData(true);
    let history_events = paymentData.history_events || [];
    history_events.push({
      date: getFlutterTime(),
      name: "Demande de paiement initiée",
    });

    const dict = {
      initiation_seconds: moment().unix(),
      master_name: orgData.name,
      admins_id: folder.admins_id,
      state: "initiated",
      amount: paymentData.amount,
      folder_ref: folder.ref,
      reglement_infos: reglement,
      master_id: orgData.id,
      nom: folder.nom,
      paid: false,
      history_events: history_events,
    };

    await updateDocApi(paymentData.ref, dict, prefix);
    await updateDocDataFieldApi(folder.ref, "reglement.state", "wait", prefix);
    if (orgData.compteurs.auto_resend_payment) {
      let date_in_one_week = moment().add(7, "days").unix();
      let parsed_date = moment.unix(date_in_one_week).format("DD/MM/YYYY");

      let trigger_date = getFlutterTimeFromSeconds(date_in_one_week);

      const dict_job = {
        date: parsed_date,
        trigger_date: trigger_date,
        type: "payment",
        counter: 0,
        status: "pending",
        nom: folder.nom,
        emails: [paymentData.reglement_infos.email],
        payment_ref: getRefFromId("payment", paymentData.id),
        folder_ref: folder.ref,
        sender_id: orgData.id,
      };
      await createDocApi("job", dict_job, prefix);
    }

    const token = await getOrRefreshFirebaseToken();
    await initiatePayment(folder.id, paymentData.id, token, prefix);
    await checkAndSendTriggerEvent(
      ["first_payment_initiated"],
      orgData,
      userData,
      prefix
    );

    await onUpdate();
    handleClickVariant("Demande de paiement initiée", "success");

    setLoadingData(false);
    navigateWorkspace("/payments");
  };

  return (
    <div className="flex flex-col bg-white rounded-3xl p-4">
      <div className="w-c300 text-h3 flex flex-row justify-between">
        Demander le paiement
        <div className="flex text-shadow_50 cursor-pointer" onClick={onClose}>
          Fermer
        </div>
      </div>
      <Space y={5} />

      <div className="w-c300 text-h3 text-shadow_50">
        Récapitulatif de la demande de paiement
      </div>
      <Space y={15} />

      <div className="flex flex-col  gap-1 rounded-xl ">
        <TextField2T
          transparent={false}
          value={reglement?.email}
          disabled={true}
          mandatory={true}
          label="Email du particulier"
        />
        <TextField2T
          transparent={false}
          value={reglement?.phone}
          disabled={true}
          mandatory={true}
          label="Téléphone du particulier"
        />
        <TextField2T
          transparent={false}
          value={reglement?.name}
          disabled={true}
          mandatory={true}
          label="Nom du particulier"
        />{" "}
        <TextField2T
          transparent={false}
          value={reglement?.first_name}
          disabled={true}
          mandatory={true}
          label="Prénom du particulier"
        />
        <TextField2T
          transparent={false}
          value={reglement?.city}
          disabled={true}
          mandatory={true}
          label="Ville du particulier"
        />
        <TextField2T
          transparent={false}
          value={reglement?.postal}
          disabled={true}
          mandatory={true}
          label="Code postal du particulier"
        />
        <TextField2T
          transparent={false}
          value={reglement?.address}
          disabled={true}
          mandatory={true}
          label="Adresse du particulier"
        />
        <InputNumber
          min={0}
          value={paymentData?.amount}
          disabled={true}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          placeholder="Montant du règlement"
          addonAfter="€"
          label="Montant du règlement"
        />
      </div>
      <Space y={20} />

      {!orgData.bridge?.connected && (
        <div className="bg-red-50 border-l-2 border-red-400 rounded-xl p-3 text-red-500 text-h2 w-fit flex flex-col mb-6">
          <div className="flex flex-row items-center gap-4">
            <Icon1 icon_name="warning" size={20} fill="red"></Icon1>
            <div className="flex flex-col gap-1">
              <div>Vous n'avez pas encore ajouté votre iban</div>
              <div>
                Cliquez sur
                <span
                  onClick={() => navigateWorkspace("/bridge")}
                  className="font-bold cursor-pointer"
                >
                  Ajouter mon iban
                </span>
                afin de recevoir les paiements.
              </div>
            </div>
          </div>
        </div>
      )}

      <PrimaryButton
        onClick={handleGeneratePayment}
        disabled={
          loadingData ||
          !reglement ||
          !paymentData?.amount ||
          !reglement?.email ||
          !reglement?.phone ||
          !reglement?.name ||
          !reglement?.first_name ||
          reglement?.first_name?.length < 3 ||
          !reglement?.city ||
          !reglement?.postal ||
          !reglement?.address ||
          paymentData?.amount === 0 ||
          !orgData.bridge?.connected
        }
      >
        <div className="flex flex-row items-center justify-center w-full">
          {loadingData ? (
            <SmallSpinner loading={loadingData} />
          ) : (
            "Initier la demande "
          )}
        </div>
      </PrimaryButton>
    </div>
  );
};

export default PaymentModal;
